import { API_URL_HACKATAO_CLAIM_TRAIT } from "@constants/Clients/hackatao/hackatao.env";
import apiInstance from "@services/Shared/instanceAxios";

const getClaimTrait = () =>
  apiInstance({
    url: API_URL_HACKATAO_CLAIM_TRAIT,
    params: {
      order: "desc",
      sort: "config.order",
    },
  });

export default getClaimTrait;
